import { render } from "./RiskscoreCard.vue?vue&type=template&id=2e438d11&scoped=true"
import script from "./RiskscoreCard.vue?vue&type=script&lang=js"
export * from "./RiskscoreCard.vue?vue&type=script&lang=js"

import "./RiskscoreCard.vue?vue&type=style&index=0&id=2e438d11&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e438d11"]])

export default __exports__